var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogoFacebookOzonorai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.54 59.54",
    style: {
      enableBackground: "new 0 0 59.54 59.54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{opacity:0.4;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FF0000;}\r\n\t.st4{fill:#2F2D7E;}\r\n\t.st5{fill:#245C9F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 29.77,
    cy: 29.77,
    r: 29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,48.16l7.36,0.02c0,0,0.03-10.16,0.05-18.41l5.47,0.02l0.69-7.36l-5.85-0.02l0.01-2.94 c0-1.43,0.96-1.77,1.63-1.76c0.67,0,4.13,0.01,4.13,0.01l0.02-6.31l-5.69-0.04c-6.31-0.02-7.76,4.68-7.77,7.7l-0.01,3.33 l-3.65-0.01l-0.02,7.36l3.68,0.01C24.83,38.09,24.8,48.16,24.8,48.16z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoFacebookOzonorai);
export default __webpack_public_path__ + "static/media/icon-logo-facebook-ozonorai.c0dc168d5e3343e73a751eb4a8cb7584.svg";
export { ForwardRef as ReactComponent };